/**
 * 从源对象中提取指定键的值，并为未定义的值提供默认值
 *
 * @param source - 源对象
 * @param keys - 要提取的键数组
 * @param defaultValue - 当源对象中对应键的值为undefined时使用的默认值
 * @returns 包含提取键值的新对象
 */
export function pickWithDefault<
  S extends object, // 源对象类型约束
  K extends readonly (keyof S)[], // 键名的只读数组类型约束
  D, // 默认值类型
>(
  source: S, // 源对象
  keys: K, // 要提取的键数组
  defaultValue: D, // 默认值
): { [P in K[number]]: Exclude<S[P], undefined> | D } {
  // 返回类型的泛型约束
  // 使用reduce方法遍历所有要提取的键，构建新对象
  return keys.reduce((acc, key) => {
    // 使用空值合并操作符(??)，当source[key]为null或undefined时使用默认值
    acc[key] = source[key] ?? defaultValue;
    return acc;
  }, {} as any); // 初始空对象，类型转换为any以满足类型检查
}

/**
 * 提取Ant Design表单验证错误的首字段提示
 * @param error - 验证错误对象
 * @returns 用户友好提示文本
 */
export const extractFormFieldError = (error: unknown): string => {
  if (error && typeof error === "object" && "errorFields" in error) {
    const errorFields = (error as any).errorFields;
    if (Array.isArray(errorFields) && errorFields.length > 0) {
      const firstField = errorFields[0];
      const errorMsg = firstField.errors?.[0] || "格式不正确";
      return `${errorMsg}`;
    }
  }
  return "请检查表单必填项及格式";
};
